import type { NewsItem } from '@/types/content';

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: '《女友的妈妈》收官口碑走高，家庭群像获观众共鸣',
    date: '2024-03-20',
    summary:
      '随着大结局播出，这部聚焦母女关系与婚恋观念的家庭剧豆瓣评分稳步上升，网友围绕「赵慧兰到底对不对」展开热烈讨论。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20magazine%20photo%20about%20a%20hit%20Chinese%20family%20drama%2C%20warm%20living%20room%20set%20with%20tea%20and%20family%20photo%20frames%2C%20soft%20window%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20magazine%20layout%20aesthetic%2C%20harmonious%20warm%20neutral%20tones&width=520&height=340&seq=drama-news01-cover-2024&orientation=landscape',
    category: '剧集动态',
    content: [
      '由沈亦航执导的家庭剧《女友的妈妈》日前正式收官。自开播以来，该剧凭借扎实的剧本与克制的表演，持续收获好评，收官当晚相关话题登上多个资讯平台热榜。',
      '观众讨论的焦点，集中在苏晚晴饰演的赵慧兰身上。她既是一位为女儿付出全部的母亲，也是一个有过遗憾与执念的普通女性。这种不完美，让角色摆脱了脸谱化，也让许多观众在弹幕中表示「看到了自己的妈妈」。',
      '导演沈亦航在采访中表示，剧本创作阶段最想探讨的，其实是「两代人如何对话」：真正让关系破裂的，往往不是冲突本身，而是谁都不肯先说出心里那句话。',
      '有评论指出，《女友的妈妈》的难得之处，在于它没有给出标准答案，而是把和解过程里的犹豫、反复与勇气如实呈现，这也正是它能引发广泛共鸣的原因。',
    ],
    episodeIds: [10, 11, 12],
  },
  {
    id: 2,
    title: '苏晚晴谈赵慧兰：我演的不是「恶婆婆」，是一个怕失去的人',
    date: '2024-03-18',
    summary:
      '主演苏晚晴在最新专访中回应角色争议，直言赵慧兰的强硬是一种自我保护，她理解的是一位母亲面对失去时的恐惧。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20interview%20photo%20of%20an%20elegant%20mature%20Chinese%20actress%20seated%20in%20a%20soft%20lit%20room%2C%20thoughtful%20expression%2C%20warm%20window%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20magazine%20interview%20aesthetic%2C%20harmonious%20warm%20neutral%20tones&width=520&height=340&seq=drama-news02-cover-2024&orientation=landscape',
    category: '主创访谈',
    content: [
      '面对观众对赵慧兰「控制欲太强」的评价，苏晚晴在专访中给出了自己的理解：「她首先是一个害怕失去的人，然后才是一个母亲。」',
      '为了演好这个角色，苏晚晴做了大量案头工作，包括与现实中经历过类似处境的女性交流。她发现，很多看起来强势的母亲，年轻的时候都曾为家庭放弃过自己想要的人生。',
      '「所以我给她设计了很多停顿。她不说话的时候，其实是在跟自己较劲。」苏晚晴说，赵慧兰的每一次沉默，都比台词更接近她的真实状态。',
      '谈到与何思彤的母女对手戏，她笑称两人在片场很少「演」，更多是自然地聊天，「先成为家人，再演家人」，这也是镜头里那种真实感的来源。',
    ],
    episodeIds: [7, 8, 9],
  },
  {
    id: 3,
    title: '林知远专访：陈默最难的不是被认可，而是学会替自己说话',
    date: '2024-03-16',
    summary:
      '男主角林知远分享拍摄心路，认为陈默的成长核心在于从「讨好所有人」到敢于表达真实想法的转变。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20interview%20photo%20of%20a%20handsome%20young%20Chinese%20male%20actor%20leaning%20by%20a%20bright%20studio%20window%2C%20calm%20confident%20expression%2C%20soft%20daylight%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20magazine%20interview%20aesthetic%2C%20harmonious%20cool%20neutral%20tones&width=520&height=340&seq=drama-news03-cover-2024&orientation=landscape',
    category: '主创访谈',
    content: [
      '在《女友的妈妈》中，林知远饰演的陈默被不少观众称为「史上最憋屈男主」。对此他并不认同：「他不是憋屈，他只是太想被所有人喜欢了。」',
      '林知远透露，为了找到陈默的状态，他特意在生活中练习「把想说的话咽回去」，去体会那种处处小心、不断自我审查的疲惫感。',
      '在他看来，全剧最重要的一场戏是雨夜守候。「那之前他一直在证明自己，那之后他开始为自己而活。承认自己也会难过，反而是最勇敢的一件事。」',
      '谈到未来，林知远表示希望继续尝试内心层次更复杂的角色，而不是重复「暖男」的舒适区。',
    ],
    episodeIds: [1, 8, 11],
  },
  {
    id: 4,
    title: '剧中考据：一碗家常菜为什么成了「关系的温度计」',
    date: '2024-03-14',
    summary:
      '有观众发现，几乎每一次关系转折都发生在饭桌边。剧组的细节设计让「吃饭」成为推动剧情的关键场景。',
    cover:
      'https://readdy.ai/api/search-image?query=Overhead%20editorial%20photo%20of%20a%20Chinese%20home%20cooked%20dinner%20table%20with%20several%20warm%20dishes%20and%20steaming%20soup%2C%20warm%20amber%20lamp%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20food%20magazine%20aesthetic%2C%20harmonious%20warm%20tones&width=520&height=340&seq=drama-news04-cover-2024&orientation=landscape',
    category: '幕后揭秘',
    content: [
      '细心的观众发现，《女友的妈妈》里几乎每一次关键转折，都发生在饭桌上。从第一次登门的一桌家宴，到结局那顿平静的晚饭，吃饭成了两代人关系的温度计。',
      '美术组表示，这是刻意为之的设计。餐桌上的菜色会随着剧情推进而变化：冲突时是刻意丰盛却无人动筷，和解后反倒是一桌最简单的家常。',
      '「中国人不习惯坐下来谈感情，但会坐下来吃饭。」编剧周晚棠在采访中说，「所以我们把想说的话，都放在了饭碗和筷子上。」',
      '这一处理也获得观众认可，不少人留言称，看到结局那桌菜时突然就哭了。',
    ],
    episodeIds: [2, 12],
  },
  {
    id: 5,
    title: '取景地成打卡地，老城区街巷迎来追剧观众',
    date: '2024-03-12',
    summary:
      '剧中主要取景的老城区街巷因剧集走红，不少观众专程前往寻找「陈默站过的楼下」与「林家窗边」。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20travel%20photo%20of%20a%20quiet%20old%20Chinese%20city%20alley%20at%20dusk%2C%20warm%20street%20lamps%20turning%20on%2C%20laundry%20lines%20and%20potted%20plants%2C%20cinematic%20shallow%20depth%20of%20field%2C%20nostalgic%20magazine%20aesthetic%2C%20harmonious%20warm%20dusk%20tones&width=520&height=340&seq=drama-news05-cover-2024&orientation=landscape',
    category: '影视资讯',
    content: [
      '随着剧集热播，剧中主要取景的老城区街巷意外走红，成了不少观众的打卡地。据附近居民介绍，周末前来拍照的年轻人明显增多。',
      '剧组美术指导透露，选址时特意避开了网红街区，看中的正是这里保留的生活气息——晾衣绳、旧楼道、楼下的小卖部，都是剧本里「家」的感觉。',
      '有观众表示，来之前只是想找找「陈默站过的楼下」，到了之后却被这种烟火气打动，「好像真的能理解赵慧兰为什么不肯搬家了」。',
      '当地社区提醒游客文明打卡，注意不要打扰居民的正常生活。',
    ],
    episodeIds: [1, 8],
  },
  {
    id: 6,
    title: '幕后：大结局那场窗边戏，一条就过了',
    date: '2024-03-10',
    summary:
      '导演沈亦航透露，赵慧兰与林夏的窗边长镜头并未使用配乐，全靠两位演员的真实情绪完成，一条即过。',
    cover:
      'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20editorial%20photo%20of%20a%20film%20set%20with%20soft%20warm%20lamps%20and%20a%20window%20overlooking%20city%20lights%2C%20cinematic%20shallow%20depth%20of%20field%2C%20quiet%20artistic%20mood%2C%20refined%20magazine%20aesthetic%2C%20harmonious%20warm%20indoor%20tones&width=520&height=340&seq=drama-news06-cover-2024&orientation=landscape',
    category: '幕后揭秘',
    content: [
      '在第九集中，赵慧兰与林夏并肩坐在窗边、几乎全程无台词的长镜头，被许多观众评为全剧最动人的一幕。',
      '导演沈亦航在采访中透露，这场戏原本写了三页台词，但排练时两位演员的状态太好，他临时决定「把台词全删掉」。「有些话说了就浅了，不说反而都在。」',
      '最终这场戏一条即过，剧组现场安静了很久。沈亦航说，监视器后面好几个人都在抹眼泪。',
      '这段长镜头也被不少影视博主拆解分析，认为它示范了「留白」在家庭题材中的力量。',
    ],
    episodeIds: [9, 12],
  },
  {
    id: 7,
    title: '行业观察：现实题材家庭剧为何持续升温',
    date: '2024-03-08',
    summary:
      '从《女友的妈妈》的热播出发，观察近两年现实题材家庭剧的创作趋势与观众审美变化。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20industry%20photo%20of%20a%20modern%20television%20studio%20monitor%20wall%20showing%20warm%20family%20drama%20scenes%2C%20dim%20control%20room%20ambience%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20magazine%20aesthetic%2C%20harmonious%20cool%20neutral%20tones&width=520&height=340&seq=drama-news07-cover-2024&orientation=landscape',
    category: '行业观察',
    content: [
      '近两年，现实题材家庭剧持续升温，《女友的妈妈》正是其中的一个缩影。与早年的家庭剧相比，新一批作品更愿意把镜头对准「关系本身」，而非简单的善恶对立。',
      '有制片人分析，观众审美正在变化：脸谱化的「恶婆婆」「凤凰男」越来越难引发共鸣，反而是有缺陷、有来由的角色更能留住人。',
      '与此同时，剧集对白密度下降、情绪留白增加，也成为现实题材的新趋势。「观众不再需要被台词告诉该有什么感受。」',
      '业内人士认为，只要创作愿意尊重生活的复杂性，家庭题材仍有很大的表达空间。',
    ],
    episodeIds: [2, 7, 11],
  },
  {
    id: 8,
    title: '网友拆解「赵慧兰的三次沉默」，一句台词都没说却全是戏',
    date: '2024-03-06',
    summary:
      '一位影视博主发布长文，逐帧分析赵慧兰在剧中三次关键沉默，引发大量观众跟帖讨论。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20laptop%20on%20a%20wooden%20desk%20showing%20a%20video%20editing%20timeline%2C%20warm%20desk%20lamp%2C%20notebook%20and%20coffee%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20magazine%20aesthetic%2C%20harmonious%20warm%20neutral%20tones&width=520&height=340&seq=drama-news08-cover-2024&orientation=landscape',
    category: '观众热议',
    content: [
      '近日，一篇标题为《赵慧兰的三次沉默》的长文在影视爱好者中广泛流传。作者逐帧拆解了该角色在剧中的三次关键沉默，认为这些「没有台词的时刻」才是全剧表演的高光。',
      '文章指出，第一次沉默发生在第一集的饭桌上，第二次是雨夜隔窗注视，第三次则是结局那句「随你们吧」之前的停顿。三次沉默层层递进，完成了人物从防御到释然的完整弧线。',
      '该分析获得大量观众认同，有人在评论区表示：「以前觉得这种戏‘闷’，看了拆解才发现全是细节。」',
      '也有观众由此延伸讨论，认为国产剧对「留白表演」的接受度正在提高，这本身是一种进步。',
    ],
    episodeIds: [1, 8, 12],
  },
  {
    id: 9,
    title: '原声带正式上线，主题曲《窗边》被赞「听完想给妈妈打电话」',
    date: '2024-03-04',
    summary:
      '《女友的妈妈》完整原声带登陆各大音乐平台，其中主题曲《窗边》因旋律温柔、歌词克制引发共鸣。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20headphones%20and%20a%20vinyl%20record%20on%20a%20warm%20wooden%20table%2C%20soft%20evening%20light%2C%20cozy%20minimal%20music%20corner%2C%20cinematic%20shallow%20depth%20of%20field%2C%20refined%20magazine%20aesthetic%2C%20harmonious%20warm%20amber%20tones&width=520&height=340&seq=drama-news09-cover-2024&orientation=landscape',
    category: '影视资讯',
    content: [
      '《女友的妈妈》完整原声带日前正式上线。专辑共收录十二首配乐与两首人声作品，其中主题曲《窗边》被大量观众循环播放。',
      '据音乐总监介绍，《窗边》的创作灵感正来自第九集那场无台词长镜头，旋律刻意保持简单，希望在安静里留下余味。',
      '歌曲上线后，评论区被「听完想给妈妈打电话」的留言刷屏，也有观众表示，这首歌唱出了剧中人始终没说出口的那句话。',
      '剧组表示，后续还将推出角色主题的特别版本，敬请期待。',
    ],
    episodeIds: [9],
  },
];